import { memo } from "react";
import { motion } from "framer-motion";
import { MemoizedMarkdown } from "./MemoizedMarkdown";

const StreamingMessage = memo(({ currentStreamingMessage, typingText, formatTime, systemImage }) => {
  return (
    <div className="flex justify-start">
      <img
        src={systemImage}
        className="w-8 h-8 rounded-full overflow-hidden border uppercase border-white/10 flex items-center justify-center bg-gray-700 text-white text-sm font-bold m-2"
        alt="System"
      />
      <div className="flex flex-col items-start gap-1 w-full">
        <div className="text-xs text-black/90 italic flex items-center gap-2">
          <span>Assistant</span>
          <span className="text-black text-[10px]">
            {formatTime(currentStreamingMessage.timestamp)}
          </span>
        </div>
        <div 
          className="bg-gradient-to-r from-primary/90 to-secondary/90 p-4 rounded-2xl rounded-tl-none text-white border border-white/10 max-w-5xl shadow-xl backdrop-blur-sm"
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {typingText ? (
            <div className="text-white/95 prose prose-invert max-w-none leading-relaxed chat-message antialiased">
              <MemoizedMarkdown id={`streaming-${currentStreamingMessage?.id}`} content={typingText} />
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="text-white/80">Thinking</span>
              <div className="flex">
                {[0, 1, 2].map((i) => (
                  <motion.span
                    key={i}
                    animate={{ opacity: [0, 1, 0] }}
                    transition={{
                      repeat: Number.POSITIVE_INFINITY,
                      duration: 0.8,
                      delay: i * 0.2,
                      repeatDelay: 0,
                    }}
                    className="h-1.5 w-1.5 bg-white/70 rounded-full ml-1"
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

StreamingMessage.displayName = "StreamingMessage";

export default StreamingMessage;